var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 details__thumb"},[_c('router-link',{attrs:{"to":{ name: 'finishedAuctionsCatalog', query: { dzielo: _vm.artwork.slug, page: _vm.$route.query.page || _vm.FIRST_PAGE, q: _vm.$route.query.q }}}},[_c('img',{attrs:{"src":_vm.artwork.imagePreviewUrl}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5704e10a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/auctions_catalogs/show/components/artwork/artwork_image.vue
// module id = 667
// module chunks = 0 1 2 3 4 5 6 7 8 10 18 87 95 337